import { css } from 'styled-components';
import { colors, radii, shadows, transitions } from './tokens';

export const focusRing = css`
  &:focus-visible {
    outline: 2px solid ${colors.accents.primary};
    outline-offset: 4px;
  }
`;

interface InteractiveOptions {
  baseShadow?: string;
  hoverShadow?: string;
}

export const interactiveSurface = ({
  baseShadow = shadows.level2,
  hoverShadow = shadows.level3,
}: InteractiveOptions = {}) => css<{$clickable?: boolean}>`
  box-shadow: ${baseShadow};
  transition: transform ${transitions.default}, box-shadow ${transitions.default}, border-color ${transitions.default}, background ${transitions.default};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  &:hover {
    ${({ $clickable }) =>
      $clickable
        ? `
            transform: translateY(-2px);
            box-shadow: ${hoverShadow};
            border-color: ${colors.accents.primary};
          `
        : ''}
  }

  ${focusRing}
`;

export const panelSurface = css`
  background: ${colors.surface.subtle};
  border-radius: ${radii.xl};
  border: 1px solid ${colors.border.subtle};
`;

export const pill = css`
  border-radius: ${radii.pill};
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;
